module.exports = __webpack_public_path__ + "img/077.48d61166.png";